// frontend/src/components/Dashboard/tabs/CopyrightFreeMusicTab.js
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { BASE_URL } from '../../../config';
import './CopyrightFreeMusicTab.css';

// SVG İkonlar
const Icons = {
  Music: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 18V5l12-2v13" />
      <circle cx="6" cy="18" r="3" />
      <circle cx="18" cy="16" r="3" />
    </svg>
  ),
  Upload: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="17 8 12 3 7 8" />
      <line x1="12" y1="3" x2="12" y2="15" />
    </svg>
  ),
  Plus: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  ),
  Check: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 6 9 17 4 12" />
    </svg>
  ),
  Pause: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="6" y="4" width="4" height="16" />
      <rect x="14" y="4" width="4" height="16" />
    </svg>
  ),
  Trash: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="3 6 5 6 21 6" />
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
      <line x1="10" y1="11" x2="10" y2="17" />
      <line x1="14" y1="11" x2="14" y2="17" />
    </svg>
  ),
  Edit: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
    </svg>
  ),
  Clock: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </svg>
  ),
  HardDrive: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <line x1="22" y1="12" x2="2" y2="12" />
      <path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" />
      <line x1="6" y1="16" x2="6.01" y2="16" />
      <line x1="10" y1="16" x2="10.01" y2="16" />
    </svg>
  ),
  BarChart: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="20" x2="12" y2="10" />
      <line x1="18" y1="20" x2="18" y2="4" />
      <line x1="6" y1="20" x2="6" y2="16" />
    </svg>
  ),
  Info: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="16" x2="12" y2="12" />
      <line x1="12" y1="8" x2="12.01" y2="8" />
    </svg>
  ),
  Play: () => (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <polygon points="5 3 19 12 5 21 5 3" />
    </svg>
  ),
  Stop: () => (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <rect x="6" y="6" width="12" height="12" rx="1" />
    </svg>
  ),
  Volume: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
      <path d="M15.54 8.46a5 5 0 0 1 0 7.07" />
    </svg>
  ),
  VolumeMute: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
      <line x1="23" y1="9" x2="17" y2="15" />
      <line x1="17" y1="9" x2="23" y2="15" />
    </svg>
  ),
  Filter: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
    </svg>
  ),
  X: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  ),
  User: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  ),
  Tag: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
      <line x1="7" y1="7" x2="7.01" y2="7" />
    </svg>
  ),
  File: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="12" y1="18" x2="12" y2="12" />
      <line x1="9" y1="15" x2="15" y2="15" />
    </svg>
  )
};

const CopyrightFreeMusicTab = ({ API_URL, showMessage }) => {
  const [musicList, setMusicList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [stats, setStats] = useState(null);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [playingId, setPlayingId] = useState(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [volume, setVolume] = useState(0.5);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingMusic, setEditingMusic] = useState(null);
  const [pendingFiles, setPendingFiles] = useState([]);
  const [uploadForm, setUploadForm] = useState({
    title: '',
    artist: '',
    category: 'dance'
  });
  const audioRef = useRef(null);
  const fileInputRef = useRef(null);

  useEffect(() => {
    fetchMusicList();
    fetchStats();
    
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current = null;
      }
    };
  }, [selectedCategory]);

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.volume = volume;
    }
  }, [volume]);

  const fetchMusicList = async () => {
    try {
      setLoading(true);
      const params = selectedCategory !== 'all' ? `?category=${selectedCategory}` : '';
      const response = await axios.get(`${API_URL}/copyright-free-music${params}`);
      setMusicList(response.data.music || []);
      if (response.data.categories) {
        setCategories(response.data.categories);
      }
    } catch (error) {
      console.error('Müzik listesi hatası:', error);
      showMessage('Müzikler yüklenemedi', 'error');
    } finally {
      setLoading(false);
    }
  };

  const fetchStats = async () => {
    try {
      const response = await axios.get(`${API_URL}/copyright-free-music/stats`);
      setStats(response.data.stats);
      if (response.data.categories) {
        setCategories(response.data.categories);
      }
    } catch (error) {
      console.error('İstatistik hatası:', error);
    }
  };

  const handleAddMusicClick = () => {
    setPendingFiles([]);
    setUploadForm({ title: '', artist: '', category: 'dance' });
    setShowUploadModal(true);
  };

  const handleFileSelect = (e) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      const mp3Files = Array.from(files).filter(f => f.name.endsWith('.mp3'));
      if (mp3Files.length > 0) {
        setPendingFiles(mp3Files);
        if (mp3Files.length === 1) {
          setUploadForm(prev => ({
            ...prev,
            title: mp3Files[0].name.replace('.mp3', '')
          }));
        }
      } else {
        showMessage('Sadece MP3 dosyaları yüklenebilir', 'warning');
      }
    }
  };

  const uploadFiles = async () => {
    if (pendingFiles.length === 0) {
      showMessage('Lütfen bir dosya seçin', 'warning');
      return;
    }
    
    setUploading(true);
    setUploadProgress(0);

    let uploaded = 0;
    const total = pendingFiles.length;

    for (const file of pendingFiles) {
      try {
        const formData = new FormData();
        formData.append('music', file);
        
        if (pendingFiles.length === 1) {
          formData.append('title', uploadForm.title || file.name.replace('.mp3', ''));
          formData.append('artist', uploadForm.artist || '');
          formData.append('category', uploadForm.category || 'dance');
        } else {
          formData.append('title', file.name.replace('.mp3', ''));
          formData.append('artist', uploadForm.artist || '');
          formData.append('category', uploadForm.category || 'dance');
        }

        await axios.post(`${API_URL}/copyright-free-music/upload`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: (progressEvent) => {
            const fileProgress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
            const totalProgress = Math.round(((uploaded + fileProgress / 100) / total) * 100);
            setUploadProgress(totalProgress);
          }
        });

        uploaded++;
        setUploadProgress(Math.round((uploaded / total) * 100));
      } catch (error) {
        console.error('Yükleme hatası:', error);
        showMessage(`${file.name} yüklenemedi`, 'error');
      }
    }

    setUploading(false);
    setUploadProgress(0);
    setPendingFiles([]);
    setUploadForm({ title: '', artist: '', category: 'dance' });
    setShowUploadModal(false);
    showMessage(`${uploaded} müzik başarıyla yüklendi`, 'success');
    fetchMusicList();
    fetchStats();
  };

  const handleDelete = async (id, title) => {
    if (!window.confirm(`"${title}" müziğini silmek istediğinize emin misiniz?`)) return;

    if (playingId === id) {
      stopAudio();
    }

    try {
      await axios.delete(`${API_URL}/copyright-free-music/${id}`);
      showMessage('Müzik silindi', 'success');
      fetchMusicList();
      fetchStats();
    } catch (error) {
      console.error('Silme hatası:', error);
      showMessage('Müzik silinemedi', 'error');
    }
  };

  const handleToggle = async (id) => {
    try {
      const response = await axios.put(`${API_URL}/copyright-free-music/${id}/toggle`);
      showMessage(response.data.message, 'success');
      fetchMusicList();
    } catch (error) {
      console.error('Toggle hatası:', error);
      showMessage('Durum değiştirilemedi', 'error');
    }
  };

  const handleEdit = (music) => {
    setEditingMusic(music);
    setShowEditModal(true);
  };

  const handleUpdateMusic = async () => {
    if (!editingMusic) return;
    
    try {
      await axios.put(`${API_URL}/copyright-free-music/${editingMusic.id}`, {
        title: editingMusic.title,
        artist: editingMusic.artist,
        category: editingMusic.category
      });
      showMessage('Müzik güncellendi', 'success');
      setShowEditModal(false);
      setEditingMusic(null);
      fetchMusicList();
    } catch (error) {
      console.error('Güncelleme hatası:', error);
      showMessage('Müzik güncellenemedi', 'error');
    }
  };

  const togglePlay = (music) => {
    if (playingId === music.id) {
      stopAudio();
    } else {
      playAudio(music);
    }
  };

  const playAudio = (music) => {
    if (audioRef.current) {
      audioRef.current.pause();
    }

    const audioUrl = `${BASE_URL}/uploads/youtube/music/${music.filename}`;
    const audio = new Audio(audioUrl);
    
    audio.volume = volume;
    
    audio.addEventListener('loadedmetadata', () => {
      setDuration(audio.duration);
    });

    audio.addEventListener('timeupdate', () => {
      setCurrentTime(audio.currentTime);
    });

    audio.addEventListener('ended', () => {
      setPlayingId(null);
      setCurrentTime(0);
    });

    audio.addEventListener('error', (e) => {
      console.error('Audio yükleme hatası:', e);
      showMessage('Müzik yüklenemedi', 'error');
      setPlayingId(null);
    });

    audio.play().then(() => {
      audioRef.current = audio;
      setPlayingId(music.id);
    }).catch((error) => {
      console.error('Oynatma hatası:', error);
      showMessage('Müzik oynatılamadı', 'error');
    });
  };

  const stopAudio = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      audioRef.current = null;
    }
    setPlayingId(null);
    setCurrentTime(0);
    setDuration(0);
  };

  const formatDuration = (seconds) => {
    if (!seconds || isNaN(seconds)) return '0:00';
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  const formatFileSize = (bytes) => {
    if (!bytes) return '0 KB';
    if (bytes < 1024 * 1024) {
      return `${(bytes / 1024).toFixed(1)} KB`;
    }
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  };

  const handleProgressClick = (e, music) => {
    if (playingId !== music.id || !audioRef.current) return;
    
    const progressBar = e.currentTarget;
    const rect = progressBar.getBoundingClientRect();
    const clickPosition = (e.clientX - rect.left) / rect.width;
    const newTime = clickPosition * audioRef.current.duration;
    
    audioRef.current.currentTime = newTime;
    setCurrentTime(newTime);
  };

  const toggleMute = () => {
    if (volume > 0) {
      setVolume(0);
    } else {
      setVolume(0.5);
    }
  };

  const getCategoryLabel = (value) => {
    const cat = categories.find(c => c.value === value);
    return cat ? cat.label : value;
  };

  return (
    <div className="copyright-free-music-tab">
      {/* Header */}
      <div className="cfm-header">
        <div className="cfm-header-content">
          <div className="cfm-header-icon">
            <Icons.Music />
          </div>
          <div className="cfm-header-text">
            <h1>Telifsiz Müzikler</h1>
            <p>YouTube paylaşımlarında kullanılacak müzik kütüphanesini yönetin</p>
          </div>
        </div>
      </div>

      {/* Stats Cards */}
      {stats && (
        <div className="cfm-stats">
          <div className="cfm-stat-card">
            <div className="cfm-stat-icon">
              <Icons.Music />
            </div>
            <div className="cfm-stat-content">
              <span className="cfm-stat-value">{stats.totalMusic}</span>
              <span className="cfm-stat-label">Toplam Müzik</span>
            </div>
          </div>
          <div className="cfm-stat-card">
            <div className="cfm-stat-icon active">
              <Icons.Check />
            </div>
            <div className="cfm-stat-content">
              <span className="cfm-stat-value">{stats.activeMusic}</span>
              <span className="cfm-stat-label">Aktif</span>
            </div>
          </div>
          <div className="cfm-stat-card">
            <div className="cfm-stat-icon usage">
              <Icons.BarChart />
            </div>
            <div className="cfm-stat-content">
              <span className="cfm-stat-value">{stats.totalUsage || 0}</span>
              <span className="cfm-stat-label">Kullanım</span>
            </div>
          </div>
          <div className="cfm-stat-card">
            <div className="cfm-stat-icon storage">
              <Icons.HardDrive />
            </div>
            <div className="cfm-stat-content">
              <span className="cfm-stat-value">{formatFileSize(stats.totalSize)}</span>
              <span className="cfm-stat-label">Toplam Boyut</span>
            </div>
          </div>
        </div>
      )}

      {/* Info Box */}
      <div className="cfm-info-box">
        <div className="cfm-info-icon">
          <Icons.Info />
        </div>
        <div className="cfm-info-content">
          <p>
            Bu müzikler etiketinde <strong>"girls"</strong> geçen YouTube içeriklerine otomatik olarak eklenecektir. 
            Müzikler rastgele seçilir ve tüm müzikler kullanıldığında liste baştan başlar.
          </p>
        </div>
      </div>

      {/* Filter */}
      <div className="cfm-filter-bar">
        <div className="cfm-filter-icon">
          <Icons.Filter />
        </div>
        <select 
          value={selectedCategory} 
          onChange={(e) => setSelectedCategory(e.target.value)}
          className="cfm-filter-select"
        >
          <option value="all">Tüm Kategoriler</option>
          {categories.map(cat => (
            <option key={cat.value} value={cat.value}>{cat.label}</option>
          ))}
        </select>
      </div>

      {/* Music List */}
      <div className="cfm-music-list">
        <div className="cfm-list-header">
          <h3>Müzik Kütüphanesi</h3>
          <div className="cfm-list-header-right">
            <button className="cfm-add-music-btn" onClick={handleAddMusicClick}>
              <Icons.Plus />
              <span>Müzik Ekle</span>
            </button>
            <span className="cfm-list-count">{musicList.length} müzik</span>
          </div>
        </div>
        
        {loading ? (
          <div className="cfm-loading">
            <div className="cfm-spinner"></div>
            <span>Yükleniyor...</span>
          </div>
        ) : musicList.length === 0 ? (
          <div className="cfm-empty">
            <div className="cfm-empty-icon">
              <Icons.Music />
            </div>
            <h4>Henüz müzik yüklenmemiş</h4>
            <p>Müzik eklemek için yukarıdaki "Müzik Ekle" butonuna tıklayın</p>
            <button className="cfm-empty-add-btn" onClick={handleAddMusicClick}>
              <Icons.Plus />
              <span>Müzik Ekle</span>
            </button>
          </div>
        ) : (
          <div className="cfm-table-wrapper">
            <table className="cfm-table">
              <thead>
                <tr>
                  <th className="th-status">Durum</th>
                  <th className="th-play">Dinle</th>
                  <th className="th-title">Müzik Bilgisi</th>
                  <th className="th-category">Kategori</th>
                  <th className="th-duration">Süre</th>
                  <th className="th-size">Boyut</th>
                  <th className="th-usage">Kullanım</th>
                  <th className="th-actions">İşlemler</th>
                </tr>
              </thead>
              <tbody>
                {musicList.map((music) => (
                  <tr key={music.id} className={`${!music.is_active ? 'inactive-row' : ''} ${playingId === music.id ? 'playing-row' : ''}`}>
                    <td className="td-status">
                      <button
                        className={`cfm-status-btn ${music.is_active ? 'active' : 'inactive'}`}
                        onClick={() => handleToggle(music.id)}
                        title={music.is_active ? 'Pasifleştir' : 'Aktifleştir'}
                      >
                        {music.is_active ? <Icons.Check /> : <Icons.Pause />}
                      </button>
                    </td>
                    <td className="td-play">
                      <button
                        className={`cfm-play-btn ${playingId === music.id ? 'playing' : ''}`}
                        onClick={() => togglePlay(music)}
                        title={playingId === music.id ? 'Durdur' : 'Dinle'}
                      >
                        {playingId === music.id ? <Icons.Stop /> : <Icons.Play />}
                      </button>
                    </td>
                    <td className="td-title">
                      <div className="cfm-music-info">
                        <span className="cfm-music-title">{music.title}</span>
                        {music.artist && (
                          <span className="cfm-music-artist">
                            <Icons.User /> {music.artist}
                          </span>
                        )}
                        <span className="cfm-music-filename">{music.original_filename}</span>
                        {playingId === music.id && (
                          <div className="cfm-player-bar">
                            <div 
                              className="cfm-player-progress"
                              onClick={(e) => handleProgressClick(e, music)}
                            >
                              <div 
                                className="cfm-player-progress-fill" 
                                style={{ width: `${duration > 0 ? (currentTime / duration) * 100 : 0}%` }}
                              />
                            </div>
                            <span className="cfm-player-time">
                              {formatDuration(currentTime)} / {formatDuration(duration)}
                            </span>
                            <div className="cfm-volume-control">
                              <button 
                                className="cfm-volume-btn"
                                onClick={toggleMute}
                                title={volume === 0 ? 'Sesi Aç' : 'Sesi Kapat'}
                              >
                                {volume === 0 ? <Icons.VolumeMute /> : <Icons.Volume />}
                              </button>
                              <input
                                type="range"
                                min="0"
                                max="1"
                                step="0.05"
                                value={volume}
                                onChange={(e) => setVolume(parseFloat(e.target.value))}
                                className="cfm-volume-slider"
                                title={`Ses: ${Math.round(volume * 100)}%`}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    </td>
                    <td className="td-category">
                      <span className={`cfm-category-badge category-${music.category || 'dance'}`}>
                        {getCategoryLabel(music.category || 'dance')}
                      </span>
                    </td>
                    <td className="td-duration">
                      <div className="cfm-duration">
                        <Icons.Clock />
                        <span>{formatDuration(music.duration)}</span>
                      </div>
                    </td>
                    <td className="td-size">{formatFileSize(music.file_size)}</td>
                    <td className="td-usage">
                      <span className="cfm-usage-badge">{music.usage_count || 0}</span>
                    </td>
                    <td className="td-actions">
                      <button
                        className="cfm-edit-btn"
                        onClick={() => handleEdit(music)}
                        title="Düzenle"
                      >
                        <Icons.Edit />
                      </button>
                      <button
                        className="cfm-delete-btn"
                        onClick={() => handleDelete(music.id, music.title)}
                        title="Sil"
                      >
                        <Icons.Trash />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Upload Modal */}
      {showUploadModal && (
        <div className="cfm-modal-overlay" onClick={() => !uploading && setShowUploadModal(false)}>
          <div className="cfm-modal" onClick={(e) => e.stopPropagation()}>
            <div className="cfm-modal-header">
              <h3>
                <Icons.Plus /> Müzik Ekle
              </h3>
              <button 
                className="cfm-modal-close" 
                onClick={() => !uploading && setShowUploadModal(false)}
                disabled={uploading}
              >
                <Icons.X />
              </button>
            </div>
            <div className="cfm-modal-body">
              {/* Dosya Seçimi */}
              <div className="cfm-form-group">
                <label>
                  <Icons.File /> MP3 Dosyası Seç
                </label>
                <div className="cfm-file-input-wrapper">
                  <input
                    ref={fileInputRef}
                    type="file"
                    accept=".mp3,audio/mpeg"
                    multiple
                    onChange={handleFileSelect}
                    disabled={uploading}
                  />
                  {pendingFiles.length > 0 && (
                    <div className="cfm-selected-files">
                      <span className="cfm-selected-count">
                        {pendingFiles.length} dosya seçildi
                      </span>
                      {pendingFiles.length === 1 && (
                        <span className="cfm-selected-name">{pendingFiles[0].name}</span>
                      )}
                      {pendingFiles.length > 1 && (
                        <ul className="cfm-selected-list">
                          {pendingFiles.slice(0, 5).map((file, index) => (
                            <li key={index}>{file.name}</li>
                          ))}
                          {pendingFiles.length > 5 && (
                            <li className="cfm-more-files">+{pendingFiles.length - 5} daha...</li>
                          )}
                        </ul>
                      )}
                    </div>
                  )}
                </div>
              </div>

              {pendingFiles.length === 1 && (
                <div className="cfm-form-group">
                  <label>
                    <Icons.Music /> Müzik Adı
                  </label>
                  <input
                    type="text"
                    value={uploadForm.title}
                    onChange={(e) => setUploadForm({...uploadForm, title: e.target.value})}
                    placeholder="Müzik adını girin"
                    disabled={uploading}
                  />
                </div>
              )}
              
              <div className="cfm-form-group">
                <label>
                  <Icons.User /> Sanatçı Adı
                </label>
                <input
                  type="text"
                  value={uploadForm.artist}
                  onChange={(e) => setUploadForm({...uploadForm, artist: e.target.value})}
                  placeholder="Sanatçı adını girin (opsiyonel)"
                  disabled={uploading}
                />
              </div>
              
              <div className="cfm-form-group">
                <label>
                  <Icons.Tag /> Kategori
                </label>
                <select
                  value={uploadForm.category}
                  onChange={(e) => setUploadForm({...uploadForm, category: e.target.value})}
                  disabled={uploading}
                >
                  {categories.length > 0 ? categories.map(cat => (
                    <option key={cat.value} value={cat.value}>{cat.label}</option>
                  )) : (
                    <>
                      <option value="dance">Dans</option>
                      <option value="edm">EDM</option>
                      <option value="house">House</option>
                      <option value="trap">Trap</option>
                      <option value="hiphop">Hip-Hop</option>
                      <option value="disco">Disco</option>
                      <option value="party">Parti</option>
                      <option value="club">Club</option>
                      <option value="pop">Pop</option>
                      <option value="latin">Latin</option>
                      <option value="chill">Chill</option>
                      <option value="other">Diğer</option>
                    </>
                  )}
                </select>
              </div>
              
              {pendingFiles.length > 1 && (
                <div className="cfm-modal-note">
                  <Icons.Info />
                  <span>Çoklu yüklemede tüm dosyalar aynı sanatçı ve kategori ile yüklenir. Müzik adları dosya adından alınır.</span>
                </div>
              )}

              {/* Upload Progress */}
              {uploading && (
                <div className="cfm-upload-progress-modal">
                  <div className="cfm-progress-bar">
                    <div className="cfm-progress-fill" style={{ width: `${uploadProgress}%` }} />
                  </div>
                  <span className="cfm-progress-text">Yükleniyor... %{uploadProgress}</span>
                </div>
              )}
            </div>
            <div className="cfm-modal-footer">
              <button 
                className="cfm-btn-cancel" 
                onClick={() => setShowUploadModal(false)}
                disabled={uploading}
              >
                İptal
              </button>
              <button 
                className="cfm-btn-upload" 
                onClick={uploadFiles}
                disabled={uploading || pendingFiles.length === 0}
              >
                {uploading ? (
                  <>Yükleniyor...</>
                ) : (
                  <>
                    <Icons.Upload /> Yükle
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Edit Modal */}
      {showEditModal && editingMusic && (
        <div className="cfm-modal-overlay" onClick={() => setShowEditModal(false)}>
          <div className="cfm-modal" onClick={(e) => e.stopPropagation()}>
            <div className="cfm-modal-header">
              <h3>
                <Icons.Edit /> Müzik Düzenle
              </h3>
              <button className="cfm-modal-close" onClick={() => setShowEditModal(false)}>
                <Icons.X />
              </button>
            </div>
            <div className="cfm-modal-body">
              <div className="cfm-form-group">
                <label>
                  <Icons.Music /> Müzik Adı
                </label>
                <input
                  type="text"
                  value={editingMusic.title}
                  onChange={(e) => setEditingMusic({...editingMusic, title: e.target.value})}
                  placeholder="Müzik adını girin"
                />
              </div>
              
              <div className="cfm-form-group">
                <label>
                  <Icons.User /> Sanatçı Adı
                </label>
                <input
                  type="text"
                  value={editingMusic.artist || ''}
                  onChange={(e) => setEditingMusic({...editingMusic, artist: e.target.value})}
                  placeholder="Sanatçı adını girin (opsiyonel)"
                />
              </div>
              
              <div className="cfm-form-group">
                <label>
                  <Icons.Tag /> Kategori
                </label>
                <select
                  value={editingMusic.category || 'dance'}
                  onChange={(e) => setEditingMusic({...editingMusic, category: e.target.value})}
                >
                  {categories.length > 0 ? categories.map(cat => (
                    <option key={cat.value} value={cat.value}>{cat.label}</option>
                  )) : (
                    <>
                      <option value="dance">Dans</option>
                      <option value="edm">EDM</option>
                      <option value="house">House</option>
                      <option value="trap">Trap</option>
                      <option value="hiphop">Hip-Hop</option>
                      <option value="disco">Disco</option>
                      <option value="party">Parti</option>
                      <option value="club">Club</option>
                      <option value="pop">Pop</option>
                      <option value="latin">Latin</option>
                      <option value="chill">Chill</option>
                      <option value="other">Diğer</option>
                    </>
                  )}
                </select>
              </div>
            </div>
            <div className="cfm-modal-footer">
              <button className="cfm-btn-cancel" onClick={() => setShowEditModal(false)}>
                İptal
              </button>
              <button className="cfm-btn-upload" onClick={handleUpdateMusic}>
                <Icons.Check /> Kaydet
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CopyrightFreeMusicTab;